export type DashboardAppearance = "modern" | "classic";

export const DASHBOARD_APPEARANCE_LABELS: Record<
  DashboardAppearance,
  { title: string; description: string }
> = {
  modern: {
    title: "Modern",
    description:
      "Rounded surfaces, glass effects, and gradients - the current default look.",
  },
  classic: {
    title: "Classic",
    description:
      "Flat layout with sharp corners - familiar, easy-to-read admin style. Supports light and dark.",
  },
};

export const DEFAULT_DASHBOARD_APPEARANCE: DashboardAppearance = "modern";
